import { v4 as uuidv4 } from 'uuid';

export function Login(props) {
	return {
		componentName: 'Login',
		componentId: uuidv4(),
		props: {
			optionsTitle: 'Escolha uma opção para entrar',
			emailAndPasswordTitle: 'Entrar com e-mail e senha',
			accessCodeTitle: 'Receber código de acesso por e-mail',
			iconLabel: 'Entrar',
			termsAndConditions: 'Aceitar os termos e condições',
			emailPlaceholder: 'Ex.: exemplo@mail.com',
			passwordPlaceholder: 'Adicione sua senha',
			forgotPassword: 'Esqueci minha senha',
			dontHaveAccount: 'Não tem uma conta? Cadastre-se',
			...props,
		},
		childrenComponents: [],
	};
}
